const pending: Set<number> = new Set<number>();

export const rememberOwnDecisions = (ids: readonly number[]): void => {
  ids.forEach((id: number): void => {
    pending.add(id);
  });
};

/**
 * Devolve `true` **e esquece** o id. O consumo é único de propósito: o registro existe só para
 * cobrir a janela entre a mutação e o refetch que ela dispara, e um id que ficasse guardado
 * silenciaria para sempre um aviso legítimo sobre a mesma linha.
 */
export const consumeOwnDecision = (id: number): boolean => pending.delete(id);

export const clearOwnDecisions = (): void => {
  pending.clear();
};
